import(/* webpackMode: "eager" */ "/app/app/galaxy/page.tsx");
